// Validation-safe Strategic Projects panel.
// No sample project names, locations, minerals, values, or statuses are displayed.
// Approved project information is published only after departmental validation.
import React from 'react';
import { Layers, Clock } from 'lucide-react';

const FeaturedProjects: React.FC = () => {
  return (
    <section className="py-16 bg-eds-bg">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-eds-fg">Strategic Projects</h2>
          <div className="mt-4 flex justify-center">
            <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-semibold px-2.5 py-1 rounded-eds-pill border bg-eds-gold/15 text-eds-earth border-eds-gold/30">
              <Clock className="w-3.5 h-3.5" /> Content Under Validation
            </span>
          </div>
        </div>
        <div className="bg-eds-surface border border-eds-border rounded-eds-lg p-8 text-center">
          <div className="w-12 h-12 rounded-eds-md bg-eds-surface-2 flex items-center justify-center mx-auto mb-4">
            <Layers className="w-6 h-6 text-eds-muted-fg" />
          </div>
          <p className="text-eds-muted-fg max-w-2xl mx-auto">
            Project information relating to geological development, mineral resource
            initiatives, and sector development programmes will be published following
            departmental validation and approval.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
